'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'business-time';
var width = 640;
var height = 512;
var aliases = ["briefcase-clock"];
var unicode = 'f64a';
var svgPathData = ['M96 160c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 54c-15.3-3.9-31.4-6-48-6-48.7 0-93.2 18.1-127 48l-273 0 0-96zm0 128l144 0 0 48c0 17.7 14.3 32 32 32l34.7 0c-1.7 10.4-2.7 21.1-2.7 32 0 16.6 2.1 32.7 6 48l-182 0c-17.7 0-32-14.3-32-32l0-128z', 'M272 32l96 0c8.8 0 16 7.2 16 16l0 48-128 0 0-48c0-8.8 7.2-16 16-16zM224 48l0 48-96 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l193.4 0c-4.7-10.2-8.5-20.9-11.4-32l-182 0c-17.7 0-32-14.3-32-32l0-128 144 0 0 48c0 17.7 14.3 32 32 32l34.7 0c1.8-11 4.6-21.7 8.3-32l-42.9 0 0-48 68 0c8.4-11.7 18.2-22.5 29-32l-273 0 0-96c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 54c11.1 2.9 21.8 6.7 32 11.4l0-65.4c0-35.3-28.7-64-64-64l-96 0 0-48c0-26.5-21.5-48-48-48L272 0c-26.5 0-48 21.5-48 48zM496 288a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBusinessTime = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;